import i18n from "./i18n"

// Get locale
var locale = "en"
let user = localStorage.getItem("__crrntUser")
if (user) {
  user = JSON.parse(user)
  let setting = user.settings.find((i) => i.key == "locale")
  if (setting) {
    locale = setting.value
  }
}
i18n.locale = locale

export const awn_notifications = {
  duration: 1500,
  animationDuration: 0,
  asyncBlockMinDuration: 10,
  position: "bottom-right",
  maxNotifications: 1,
  icons: {
    alert: "exclamation-triangle"
  },
  messages: {
    "async-block": ""
  },
  labels: {
    confirm: i18n.t("global.confirm_message")
  }
}
